/**
 *
 * @module grant
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString
} = Check.assert;

/**
 *
 * @class Grant
 * @desc Provides a base implementation for a grant.
 *
 */
export default class Grant {

    /**
     *
     * @param {String} grantType
     * @param {String} assertion
     *
     */
    constructor(grantType, assertion) {

        const errorMessage = {
            ctor: 'Grant(grantType, assertion)',
            get grantType() {
                return `${this.ctor} grantType should be a String with length`;
            },
            get assertion() {
                return `${this.ctor} assertion should be a String with length`;
            }
        };

        if (Check.assigned(grantType)) {
            nonEmptyString(grantType, errorMessage.grantType, InvalidArgumentException);
        }

        nonEmptyString(assertion, errorMessage.assertion, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets or sets the grant type. This must be a valid type that is recognized by the service.
         *
         */
        this.grantType = grantType;

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets or sets the packet of security information for the token.
         *
         */
        this.assertion = assertion;

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets or sets the subject token type key used to lookup
         * the subject_token_type value needed during token exchange.
         * @note for lookup purposes only, should not be included in a request body.
         *
         */
        this.subjectTokenTypeKey = '';

    }

}



// WEBPACK FOOTER //
// ./src/services/token/grant.js